import React from 'react';
import { Smartphone, FileText, Clock, Router, Wifi } from 'lucide-react';
import { whyRegisterSteps } from '../mock';

const iconMap = {
  smartphone: Smartphone,
  'file-text': FileText,
  clock: Clock,
  router: Router,
  wifi: Wifi,
};

const WhyRegisterSection = () => {
  return (
    <div className="bg-white py-20" style={{ marginTop: '-40px', position: 'relative', zIndex: 5 }}>
      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-16">
          <span
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 700,
              fontSize: '13px',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: '#FF7A00',
              marginBottom: '12px',
              display: 'block',
            }}
          >
            Why Choose Us
          </span>
          <h2
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(1.8rem, 4vw, 2.6rem)',
              color: '#1701E4',
              marginBottom: '14px',
              lineHeight: 1.15,
            }}
          >
            Register With Us — <span style={{ color: '#FF7A00' }}>Zero Hassle</span>
          </h2>
          <p
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 300,
              fontSize: '1.05rem',
              color: '#555',
              maxWidth: '500px',
              margin: '0 auto',
              lineHeight: 1.7,
            }}
          >
            As your authorized Unifi reseller, we make signing up the easiest decision you&apos;ll ever make.
          </p>
        </div>

        {/* Steps – minimal premium */}
        <div className="relative">
          {/* Dotted connector line */}
          <div
            aria-hidden
            className="absolute top-[58px] left-[10%] right-[10%] hidden md:block"
            style={{
              borderTop: '2px dashed #FFD6B0',
              zIndex: 0,
            }}
          />
          <div className="grid grid-cols-5 gap-5 relative" style={{ zIndex: 1 }}>
            {whyRegisterSteps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div
                  key={step.id}
                  className="step-card flex flex-col items-center text-center"
                >
                  {/* Numbered circle with icon */}
                  <div
                    className="step-icon-wrap"
                    style={{
                      width: '116px',
                      height: '116px',
                      borderRadius: '50%',
                      background: '#fff',
                      border: '1px solid #FFE3CB',
                      boxShadow: '0 6px 24px rgba(255,122,0,0.10)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                    }}
                  >
                    <Icon
                      strokeWidth={1.6}
                      style={{ width: '44px', height: '44px', color: '#FF7A00' }}
                    />
                    {/* Step number badge */}
                    <span
                      style={{
                        position: 'absolute',
                        top: '-6px',
                        right: '-6px',
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                        background: '#FF7A00',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 800,
                        fontSize: '13px',
                        boxShadow: '0 4px 10px rgba(255,122,0,0.35)',
                      }}
                    >
                      {index + 1}
                    </span>
                  </div>

                  {/* Title */}
                  <p
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#1a1a2e',
                      marginTop: '24px',
                      lineHeight: 1.45,
                      maxWidth: '170px',
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }}
                  >
                    {step.title.replace(/\n/g, ' ')}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <style>{`
        .step-card .step-icon-wrap {
          will-change: transform;
        }
        .step-card:hover .step-icon-wrap {
          transform: scale(1.06);
          box-shadow: 0 10px 32px rgba(255,122,0,0.22);
        }
      `}</style>
    </div>
  );
};

export default WhyRegisterSection;
